
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const FlowPage = lazy(() => import('../pages/flow/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

import PricingPage from '../pages/pricing/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/flow',
    element: <FlowPage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
